import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import VueCarousel from '@chenfengyuan/vue-carousel'
import 'bootstrap'
import vueSmoothScroll from 'vue2-smooth-scroll'
import vueScrollTo from 'vue-scrollto'
import VueGtag from "vue-gtag"
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
// Vue.use(VueCarousel)
Vue.use(VueMeta)
Vue.use(vueSmoothScroll)
Vue.use(vueScrollTo)
Vue.use(VueGtag, {
  config: { id: "UA-160762827-1" }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
